import { globalStorage } from 'services/globalStorage';

import { playerStorage } from '../../storages';

export function handlePlaying() {
  playerStorage.clearIsPlayBackPausedAndSavedCurrentTime();
  globalStorage.clearIsPlayerError();
}
